var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownSLine = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.99861 10.9763L14.1234 6.85156L15.3019 8.03007L9.99861 13.3334L4.69531 8.03007L5.87383 6.85156L9.99861 10.9763Z",
  fill: "#1E1F2F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownSLine);
export { ForwardRef as ReactComponent };